import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";

import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";

const { post, get } = request;
const initialRoute = "employer";
const { Authorization, Bearer } = AUTHORIZATION;

export const postPremiumRecalculationForm = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		// const endpoint = `${initialRoute}/premium-recalculation/post-premium-recalculation`;
		const endpoint = `${initialRoute}/premium-recalculation/dynamic-post-premium-recalculation`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		// console.log("API-RESPONSE", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const postPremiumValidationForm = async (_payload: any) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/premium-recalculation/dynamic-post-premium-validation`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		// console.log("API-RESPONSE", response);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

export const getLastRecalculationRun = async (filterQuery: { plan_code: string; group_number: string | number }) => {
	try {
		const endpoint = `${initialRoute}/premium-recalculation/recalculation-logs`;
		const token = localStorage.getItem("@jwt");

		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filterQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result; // { last_run_at, recalculated_this_month }
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

// this fetches the available validation record creatd by scheduler
export const getAvailableReportMonths = async (filterQuery: { group_number: string | number; plan_code: string }) => {
	try {
		const endpoint = `${initialRoute}/premium-recalculation/available-report-months`;
		const token = localStorage.getItem("@jwt");

		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filterQuery
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};

// it download the validation result created by scheduler
export const getValidationReport = async (_payload: {
	group_number: string | number;
	plan_code: string;
	report_month: string;
}) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/premium-recalculation/validation-results`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result; // stored report, or null if none for that month
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
// it download the recalcualtion result created by scheduler
export const getRecalculationReport = async (_payload: {
	group_number: string | number;
	plan_code: string;
	report_month: string;
}) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/premium-recalculation/recalculation-results`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result; // stored report, or null if none for that month
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
